<!-- 杠杆式外汇交易账户申请表单 -->
<template>
  <div class="mt5-apply-form">
    <div class="card-base card-shadow--small p-30">
      <el-form :model="ruleForm" :rules="rules" ref="mt5RuleForm" class="demo-ruleForm">
        <h2 class="account-info-title">{{translateTradeAccountType(tradeAccountType)}}{{$t('common.applyText')}}</h2>
        <div class="refuse-reason" v-if="this.status==='REJECT'">
          <img src="../../../../assets/images/notice.png" alt="">
          <b>{{remark}}</b>
        </div>
        <p class="statement font-s-pf-black" v-html="$t('applyTradeAccount.mt5ApplyForm.tipsTitle')"></p>
        <p class="statement font-s-pf">{{$t('applyTradeAccount.mt5ApplyForm.recomfireText')}}</p>
        <p class="statement font-s-pf">{{$t('applyTradeAccount.mt5ApplyForm.investmentExperienceText')}}</p>
        <el-form-item class="ops-font">
          <el-radio-group v-model="ruleForm.experience">
            <el-radio label="lt1Year">{{investmentExperienceOps.a}}</el-radio>
            <el-radio label="1To5Years">{{investmentExperienceOps.b}}</el-radio>
            <el-radio label="6To10Years">{{investmentExperienceOps.c}}</el-radio>
            <el-radio label="gt10Years">{{investmentExperienceOps.d}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <p class="statement font-s-pf">{{$t('applyTradeAccount.mt5ApplyForm.investmentObjectiveText')}}</p>
        <el-form-item class="ops-font">
          <el-checkbox-group v-model="ruleForm.purpose">
            <el-checkbox label="speculation" name=speculation class="labels">{{investmentObjectiveOps.a}}</el-checkbox>
            <el-checkbox label="hedging" name="hedging" class="labels">{{investmentObjectiveOps.b}}</el-checkbox>
            <el-checkbox label="asset" name="asset" class="labels">{{investmentObjectiveOps.c}}</el-checkbox>
            <el-checkbox label="income" name="income" class="labels">{{investmentObjectiveOps.d}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <p class="statement font-s-pf">{{$t('applyTradeAccount.mt5ApplyForm.riskToleranceText')}}</p>
        <el-form-item class="ops-font">
          <el-radio-group v-model="ruleForm.riskTolerance">
            <el-radio label="high">{{riskToleranceTextOps.a}}</el-radio>
            <el-radio label="medium">{{riskToleranceTextOps.b}}</el-radio>
            <el-radio label="low">{{riskToleranceTextOps.c}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="statement font-s-pf">{{$t('applyTradeAccount.companyName')}}</p>
        <el-form-item class="ops-font" v-if="isregisteredcompany">
          <el-input type="text" v-model="companyName" :disabled="true" ></el-input>
        </el-form-item>
        <p class="statement font-s-pf" v-if="isShowYears">{{$t('applyTradeAccount.employmentYears')}}</p>
        <el-form-item class="ops-font" prop="employerNumber" v-if="isShowYears">
          <el-input type="number" :min="1" :max="100" v-model="ruleForm.employerNumber" :placeholder="$t('applyTradeAccount.pleaseInput')"></el-input>
        </el-form-item>

        <p class="statement font-s-pf">
          <el-checkbox v-model="ruleForm.checked1" test_id= "checkbox2">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.mt5ApplyForm.confirmInformationText')}}
            </span>
          </el-checkbox>
          </p>
        <p class="statement font-s-pf" v-html="$t('applyTradeAccount.mt5ApplyForm.confirmInformationTips')"/>
        <el-form-item >
          <el-checkbox v-model="ruleForm.checked2" test_id= "checkbox2">
            <span class="font-s-pf">
          {{$t('applyTradeAccount.mt5ApplyForm.riskStatement.header')}}
            </span>
          </el-checkbox>

          <a class="font-16" :href="$t('applyTradeAccount.mt5ApplyForm.riskStatement.rulesLink')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.mt5ApplyForm.riskStatement.rules')}}</span>
          </a>
           <p class="font-s-pf" v-html="$t('applyTradeAccount.mt5ApplyForm.riskStatementFoot')" />
        </el-form-item>
        <el-form-item prop="checked3" style="margin-top:-20px">
          <el-checkbox v-model="ruleForm.checked3" test_id= "checkbox3">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.infomationTips.textOne')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.infomationTips.linkOne')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkOneText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.textTwo')}}</span>
          <a :href="standingLink" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkTwoText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.lastText')}}</span>
        </el-form-item>
      </el-form>
      <mt5ArticleContent
      v-if="showMt5ArticleContent"
      @submitForm="submitForm"
      :status="status"
      />
       <div class="eddidTips" v-else>
        <p class="font-sx-pf">{{$t('applyTradeAccount.tipsText1')}}</p>
        <p>{{$t('applyTradeAccount.tipsText2')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import mt5ArticleContent from './mt5ArticleContent'
import { getAgreementContent } from '@/api/v2/deposit.js'
import { mapState } from 'vuex'
export default {
  components: { mt5ArticleContent },
  props: {
    status: {
      type: String,
      default: ''
    },
    tradeAccountType: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ruleForm: {
        experience: '',
        purpose: [],
        riskTolerance: 'high',
        infoIsSome: 'yes',
        checked1: false,
        checked2: false,
        checked3: false,
        employerNumber: ''
      },
      showMt5ArticleContent: true,
      rules: {},
      companyName: '',
      isShowYears: true,
      isregisteredcompany: true,
      standingLink: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
    investmentExperienceOps () {
      return this.$t('applyTradeAccount.mt5ApplyForm.investmentExperienceOps')
    },
    investmentObjectiveOps () {
      return this.$t('applyTradeAccount.mt5ApplyForm.investmentObjectiveOps')
    },
    riskToleranceTextOps () {
      return this.$t('applyTradeAccount.mt5ApplyForm.riskToleranceTextOps')
    },
    confirmInformationOps () {
      return this.$t('applyTradeAccount.mt5ApplyForm.confirmInformationTips')
    }
  },
  created () {
    if (['retired', 'unemployed'].includes(this.userInfo.employmentStatus)) {
      this.companyName = this.$t('applyTradeAccount.hideYears')
      this.isShowYears = false
    } else {
      this.companyName = this.userInfo.companyName || ' '
      this.isShowYears = true
    }
    // 自雇无营业执照的，不显示公司，与不显示受雇年期；有营业执照的，要显示公司名称，显示受雇年期；
    if (this.userInfo.employmentStatus === 'self' && this.userInfo.registeredCompany === 'N') {
      this.isregisteredcompany = false
      this.isShowYears = false
    } else {
      this.isregisteredcompany = true
    }
    this.getAgreementContentFun()
  },
  methods: {
    translateTradeAccountType (tradeAccountType) {
      return this.$t('tradeAccountType.' + tradeAccountType)
    },
    submitForm (val) {
      this.$emit('createAccount', { agree: true, infoIsSome: this.ruleForm.infoIsSome, ruleForm: { experience: this.ruleForm.experience, purpose: this.ruleForm.purpose, riskTolerance: this.ruleForm.riskTolerance, checked1: this.ruleForm.checked1, checked2: this.ruleForm.checked2, checked3: this.ruleForm.checked3, employerNumber: this.ruleForm.employerNumber, isShowYears: this.isShowYears } })
    },
    changeInformation (val) {
      this.showMt5ArticleContent = val !== 'no'
    },
    // 获取常设授权链接
    async getAgreementContentFun() {
      let params = {
        platform: 'H5',
        type: 'Standing_Authority'
      }
      let res = await getAgreementContent(params)
      if (res.code === 200) {
        this.standingLink = res.data && res.data.path
      }
    }
  }
}
</script>
<style lang="scss">
.mt5-apply-form {
.el-checkbox__label {
  font-size: 14px!important;
  padding-left: 10px!important;
  }
  .el-checkbox .el-checkbox__label {
    color: #606266;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #fec000;
  }
  .font_blod{
    font-weight:bold
  }
}
</style>

<style lang="scss" scoped>
.mt5-apply-form{
  //  /deep/ .el-radio{
  //   color: #000
  // }
  //  /deep/  .el-checkbox__label{
  //   color: #000!important
  // }
  .p-30{
    padding: 0px 30px 30px 30px;
  }
  h3 {
    color: rgba(36, 40, 45, 1);
    font-size: 16px;
    font-family: Muli-Bold;
  }
  .ops-font{
    font-size:15px !important;;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1) !important;
    line-height:15px;
  }
  /deep/.el-input{
    width: 40% !important;
  }
  .account-info-title {
    font-family: Muli-Bold;
    font-size: 18px !important;
    color: #182a54 !important;
    letter-spacing: 0.22px;
    border-bottom: 3px solid #ebebeb;
    padding: 10px 5px 20px;
  }
  .refuse-reason {
    background: rgba(254, 192, 0, 0.2);
    border-radius: 6px;
    padding: 20px;
    line-height: 30px;
    word-break: break-all;
    img {
      vertical-align: middle;
    }
    b {
      font-family: Muli-Bold;
      font-size: 14px;
      color: #192b57;
      letter-spacing: 0;
      line-height: 50px;
      padding-left: 20px;
    }
  }
  .statement{
    font-size: 16px;
  }
}
</style>
